
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import moment from "moment";

export const RoadWorkApprovalExportData = (props) => {
    const { ExcelData, name, searchName } = props
    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-FarmerMasterExport"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'black' }}
            />
            <table id="table-to-FarmerMasterExport" style={{ display: 'none', width: '100%' }}>

                <h5><span>&emsp;</span></h5>

                <tr>
                    <th colSpan={searchName === 'Pending' ? 7 : searchName === 'Rejected' ? 9 : 9} style={{ textAlign: 'center', fontSize: 16, border: '1px solid black' }}>{name}</th>
                </tr>

                {/* <tr><td></td></tr> */}

                <thead className="thead-dark" >
                    <tr style={{ backgroundColor: '#254462', color: "#fff" }}>
                        <th style={{ borderLeft: "1px solid black" }}>Sr.No.</th>
                        <th style={{ borderLeft: "1px solid white" }}>Location Name</th>
                        <th style={{ borderLeft: "1px solid white" }}>Work Area</th>
                        <th style={{ borderLeft: "1px solid white" }}>Work Name</th>
                        <th style={{ borderLeft: "1px solid white" }}>Work Number</th>
                        <th style={{ borderLeft: "1px solid white" }}>Work Upload Date</th>
                        {
                            searchName == "Pending" ?
                                <>
                                    <th style={{ borderLeft: "1px solid white" }}>Status</th>
                                </>
                                : ''
                        }

                        {
                            searchName == "Rejected" ?
                                <>
                                    <th style={{ borderLeft: "1px solid white" }}>Rejected by</th>
                                    <th style={{ borderLeft: "1px solid white" }}>Rejected Date</th>
                                    <th style={{ borderLeft: "1px solid white" }}>Remark</th>
                                </>
                                : ''
                        }
                        {
                            searchName == "Approved" ?
                                <>
                                    <th style={{ borderLeft: "1px solid white" }}>Approved by</th>
                                    <th style={{ borderLeft: "1px solid white" }}>Approved Date</th>
                                    <th style={{ borderLeft: "1px solid white" }}>JE / DE Name</th>
                                </>
                                : ''
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table.map((item, i) => (
                            <tr style={{ textAlign: "center", border: '1px solid black' }}>
                                <td >{item.rowNum}</td>
                                <td>{item.locationName ? item.locationName : '-'}</td>
                                <td>{item.workArea ? item.workArea : '-'}</td>
                                <td>{item.workName ? item.workName : '-'}</td>
                                <td>{item.workNumber ? item.workNumber : '-'}</td>
                                <td>{item.workUploadDate ? item.workUploadDate : '-'}</td>
                                {/* <td>
                                                                        <span>
                                                                            <i class="fa-solid fa-eye ms-2" style={{ cursor: 'pointer' }} title='View'
                                                                                onClick={() => handleShowImage(item.beforeWork)}
                                                                            ></i>
                                                                        </span>
                                                                    </td> */}

                                {
                                    searchName == "Pending" ?
                                        <>
                                            <td>{item.statusName ? item.statusName : '-'}</td>
                                        </>
                                        : ''
                                }
                                {
                                    searchName == "Rejected" ?
                                        <>
                                            <td>{item.approved_By ? item.approved_By : '-'}</td>
                                            <td>{item.approveRejectedActionDate ? moment(item.approveRejectedActionDate).format("DD-MM-YYYY") : '-'}</td>
                                            <td>{item.remark ? item.remark : '-'}</td>
                                        </>
                                        : ''
                                }
                                {
                                    searchName == "Approved" ?
                                        <>
                                            <td>{item.approved_By ? item.approved_By : '-'}</td>
                                            <td>{item.approveRejectedActionDate ? moment(item.approveRejectedActionDate).format("DD-MM-YYYY") : '-'}</td>
                                            <td>{item.jE_DE_ByName ? item.jE_DE_ByName : '-'}</td>
                                        </>
                                        : ''
                                }

                            </tr>
                        )) : <tr>No data</tr>
                    }
                </tbody>
            </table>
        </div>
    )
}